import Axios from "../config/Axios";

export const ApiCrearUsuarioTipoConRango = async (data) => {
  /*
    
{ "tipo":"EMPLEADOS", "rango_init":"1", "rango_end":"3000" }
{ "tipo":"CUADRILLA", "rango_init":"5000", "rango_end":"8000" }
{ "tipo":"OTROS", "rango_init":"8000", "rango_end":"11000" }
DETALLE:
"SE DEBE INGRESAR DE FORMA INDIVIDUAL CADA REGISTRO PD: NO ESTA VALIDADO QUE SE REPITA EL TIPO"

    */
  try {
    const result = await Axios.post(`/POSTcreateTipoUser`, data);
    return result.data;
  } catch (e) {
    return [
      {
        sms: "err",
        data: [],
        mensaje: e,
      },
    ];
  }
};

export const ApiObtenerRangosSistema = async () => {
  try {
    const result = await Axios.get(`/GETdataRangosSistema`);
    return result.data;
  } catch (e) {
    return [
      {
        sms: "err",
        data: [],
        mensaje: e,
      },
    ];
  }
};

export const ApiEditarUsuarioTipoConRango = async (data) => {
  /**
     * { "tipo":"EMPLEADOS", "rango_init":"1", "rango_end":"1000","activo":true,"pre_tipo_usuario_id":"1" }
DETALLE:
"SE DEBE INGRESAR DE FORMA INDIVIDUAL CADA REGISTRO 
 PARA CAMBIAR EL ESTADO DE ACTIVO O INACTIVO SOLO SE DEBE PONER TRUE O FALSO EN LA MISMA FUNCION 
  PD: NO ESTA VALIDADO QUE SE REPITA EL TIPO
"

     */
  try {
    const result = await Axios.post(`/POSTupdateTipoUser`, data);
    return result.data;
  } catch (e) {
    return [
      {
        sms: "err",
        data: [],
        mensaje: e,
      },
    ];
  }
};

export const ApiGetAllTiposUsuarioXRango = async (data) => {
  /**
     * RETURN :{
	"sms": "ok",
	"mensaje": "se cargaron 1 registros",
	"data": [+
		{
			"pre_tipo_usuario_id": 1,
			"tipo": "EMPLEADOS",
			"rango_init": 1,
			"rango_end": 3500,
			"activo": true
		}
	]
}
     */
  try {
    const result = await Axios.get(`/GETdataTiposUser`);
    return result.data;
  } catch (e) {
    return [
      {
        sms: "err",
        data: [],
        mensaje: e,
      },
    ];
  }
};

export const ApiActualizarUsuariosSegunRangoCode = async (data) => {
  /**

     */
  try {
    const result = await Axios.post(`/POSTupdateRangosUsers`, data);
    return result.data;
  } catch (e) {
    return [
      {
        sms: "err",
        data: [],
        mensaje: e,
      },
    ];
  }

  /**
   * DATAINDIVIDUAL:{
   * "usuarios":[
		{
			"pre_usuario_id": 33,		
			"code": "1358",
        }]
    }
DETALLE:
"SE DEBEN ENVIAR LA INFO DEL JSON DEL USUARIO EN UN ARRAY DE NO MAS DE 25 IETMS
"
   */

  ////////////retorna
  /**
 * {
	"sms": "ok",
	"mensaje": "registros actualizados",
	"data": [
		{
			"code_err": "ok",
			"mensaje": "ok",
			"data": {
				"pre_usuario_id": 33,
				"nombres": "JESSICA ANDREINA",
				"apellidos": "MOREIRA GARCIA",
				"code": "1358",
				"pre_tipo_usuario_id": 1
			}
		}
	],
	"datanocode": []
}
 */
};
